<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-role-create">

    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-1">Create a role</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <div class="vx-card p-4">
              <role-create-details ref="details" v-model="data"/>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="cancel"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            @click="saveChanges"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import RoleCreateDetails from "@/views/pages/role/create/RoleCreateDetails";
import FormValidateMixin from "@/components/mixins/FormValidateMixin";

export default {
  components: {
    RoleCreateDetails,
  },
  mixins: [FormValidateMixin],
  data() {
    return {
      data: {},
      forms: [
        'details',
      ]
    };
  },
  methods: {
    async saveChanges () {
      /* eslint-disable */

      if (!await this.isValid()) {
        return;
      }

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
      const params = {
        ...this.data,
        Application_PK: this.data.applicationId
      };

      try {
        await this.$api.roles.create(params);
        this.$vs.notify({
          title: 'Role created',
          iconPack: 'feather',
          color: 'success',
          position: 'top-right'
        })
        this.$router.push({ name: 'role.list' });
      } catch (e) {
        this.addErrors(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to create role. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },

    cancel() {
      this.$router.push({name: 'role.list'});
    }
  },
}

</script>
